<template>

  <v-container fluid>
    <v-alert type="error" v-if="hasError" :value="!!error">{{this.error}}</v-alert>
    <v-flex>
      <v-text-field
        v-for="(val, key) in customerItem"
        :key="key"
        :label="key"
        :value="val"
        :readonly="['id', 'customerId', 'customerIdUnique'].includes(key)"
        v-model="customerItem[key]"
      ></v-text-field>

      <v-btn @click.stop="dialogSave = true">Save changes</v-btn>
      <v-dialog
        v-model="dialogSave"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">Confirm</v-card-title>
  
          <v-card-text>
            Are you sure you want to save your changes?
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
  
            <v-btn
              @click="dialogSave = false"
            >
              Cancel
            </v-btn>
  
            <v-btn
              @click="dialogSave = false; updateCustomer()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-btn @click.stop="dialogDelete = true">Delete</v-btn>
      <v-dialog
        v-model="dialogDelete"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">Confirm</v-card-title>
  
          <v-card-text>
            Are you sure you want to delete this contact?
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
  
            <v-btn
              @click="dialogDelete = false"
            >
              Cancel
            </v-btn>
  
            <v-btn
              @click="deleteCustomer()"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


    </v-flex>
  </v-container>
</template>

<script>
  import AWS from 'aws-sdk';

  export default {

    data() {
      return {
        dialogSave: false,
        dialogDelete: false,
        customerItem : {},
        error: "",
        hasError: false
      }
    },
    created() {
      this.dataService.getCustomerEditPage(this.$route.params.id).then(result => {
        console.log('getcustomer ' , result.data);
        this.customerItem = result.data;
      });
    },

    methods: {
      updateCustomer() {
         this.hasError = false
        this.dataService.updateCustomer(this.$route.params.id, this.customerItem)
        .catch(err => {
          this.error = "Error while updating Customer"
          this.hasError = true
        })        
      },

      deleteCustomer() {
         this.hasError = false
        this.dataService.deleteCustomer(this.customerItem.customerId)
        .catch(err => {
          console.log('ERROR')
          this.error = "Error while deleting: " + err.message
          this.hasError = true
        })
        .then( () => {
          if(!this.hasError) {
            this.$router.push({ path: '/customers' })
          }
        })
      }
    }

  }

</script>



// WEBPACK FOOTER //
// GetCustomer.vue?40a24950